<template>
  <!-- for more info, https://vuetifyjs.com/en/components/snackbars/ -->
  <v-snackbar
    class="toast-container f1-5"
    :value="show"
    :bottom="y === 'bottom'"
    :color="color"
    :left="x === 'left'"
    :multi-line="mode === 'multi-line'"
    :right="x === 'right'"
    :timeout="duration"
    :top="y === 'top'"
    :vertical="mode === 'vertical'"
    @input="resetToast"
  >
    <span class="mr2 text-center w100p f2">{{ message }}</span>
    <bh-icon class="pointer" icon="cross" @output.self="resetToast" />
  </v-snackbar>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'bh-toast',
  props: {
    message: {
      type: String,
      default: 'This is a toast message'
    },
    duration: {
      type: Number,
      default: 3000
    },
    color: {
      type: String,
      default: '#00C853'
    },
    x: {
      type: String,
      default: ''
    },
    y: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'multi-line'
    },
    classes: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(['resetToast'])
  }
}
</script>

<style scoped>
  .toast-container {
    z-index: 999999999;
  }
</style>
